/**
 * CHART OF ACCOUNTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getChartOfAccounts,
    getChartOfAccount,
    printChartOfAccount,
    createChartOfAccounts,
    updateChartOfAccounts,
    deleteChartOfAccounts,
} from "Core/configuration/chart_of_accounts/config/api.chart_of_accounts";

const state = {
    page: {},
    form: {},
    chart_of_accounts: [],
    selectedChartOfAccount: {
        account_id: null,
        company_id: "",
        chart_of_account_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        chart_of_account_details: [],
    },
    chart_of_accounts_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        status: "1",
    },
    rules_chart_of_accounts: {
        account_id: {
            name: "account_id",
            rules: "trim|max_length[11]|integer|required",
            max_len: "11",
            min_len: "",
            default_value: "",
        },
        account_code: {
            name: "account_code",
            rules: "trim|max_length[20]|required",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        account_name: {
            name: "account_name",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        account_type: {
            name: "account_type",
            rules: "trim|required",
            max_len: "9",
            min_len: "",
            default_value: "",
        },
        is_active: {
            name: "is_active",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
    },
};

// getters
const getters = {
    chart_of_accounts: (state) => {
        return state.chart_of_accounts;
    },
};

// actions
const actions = {
    async fetchChartOfAccounts({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getChartOfAccounts({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageChartOfAccounts", response.data.page);
                }

                commit("setChartOfAccounts", response.data.chart_of_accounts);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchChartOfAccount({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getChartOfAccount(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedChartOfAccount", response.data.chart_of_account);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printChartOfAccount({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printChartOfAccount(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveChartOfAccount({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["account_id"] === "undefined" || body["account_id"] == null || body["account_id"] == "") {
                delete body["account_id"];
                response = await createChartOfAccounts({ body: body, headers: config.headers });
            } else {
                let account_id = body["account_id"];
                delete body["account_id"];
                response = await updateChartOfAccounts({ body: body, headers: config.headers }, account_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteChartOfAccount({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteChartOfAccounts(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageChartOfAccounts(state, page) {
        state.page = page;
    },
    setChartOfAccounts(state, chart_of_accounts) {
        state.chart_of_accounts = chart_of_accounts;
    },
    setSelectedChartOfAccount(state, chart_of_account) {
        state.selectedChartOfAccount = chart_of_account;
    },
    resetSelectedChartOfAccount(state) {
        for (const key in state.selectedChartOfAccount) {
            if (key in state.rules_chart_of_accounts) {
                state.selectedChartOfAccount[key] =
                    state.rules_chart_of_accounts[key].default_value == "null" ? null : state.rules_chart_of_accounts[key].default_value;
            }
        }
    },
    resetChartOfAccounts(state) {
        state.page = {};
        state.form = {};
        state.chart_of_accounts = [];
        state.selectedChartOfAccount = {
            account_id: null,
            company_id: "",
            chart_of_account_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            chart_of_account_details: [],
        };
        state.chart_of_accounts_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
            status: "1",
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
